// Use this to detect our screen resolution
const screenResolution = window.screen;

// This is based on our specs.
const isMobile = screenResolution.width <= 768;
const isTablet = screenResolution.width <= 1024;

// If it's false, do nothing.  But if it's a browser, we need to now determine if the event exists
// This is a better indication of whether something is mobile.
export { screenResolution, isMobile, isTablet };
try {
    // @ts-ignore
    Screen.displayName = "Screen";
    // @ts-ignore
    Screen.__docgenInfo = { "description": "A screen, usually the one on which the current window is being rendered, and is obtained using window.screen.", "displayName": "Screen", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/utils/browserProperties.ts#Screen"] = { docgenInfo: Screen.__docgenInfo, name: "Screen", path: "src/utils/browserProperties.ts#Screen" };
}
catch (__react_docgen_typescript_loader_error) { }